import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import LearnerManager from "./LearnerManager";
import DatasetHealth from "./DatasetHealth";
import SchoolManager from "./SchoolManager";
import SchoolDetail from "./SchoolDetail";
import PoolReadiness from "./PoolReadiness";
import FLNHealth from "./FLNHealth";
import MitraaResponses from "./MitraaResponses";
import QuestionFlags from "./QuestionFlags";
import FuelRegistry from "./FuelRegistry";
import DatasetOperations from "./DatasetOperations";
import SvgCacheManager from "./SvgCacheManager";

export default function AdminApp() {
  const [token, setToken] = useState(() => sessionStorage.getItem("admin_token"));

  const handleLogin = (newToken) => {
    sessionStorage.setItem("admin_token", newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("admin_token");
    setToken(null);
  };

  if (!token) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <AdminLayout onLogout={handleLogout}>
      <Routes>
        <Route index element={<Navigate to="/admin/learners" replace />} />
        <Route path="learners"       element={<LearnerManager  token={token} onUnauth={handleLogout} />} />
        <Route path="schools"        element={<SchoolManager   token={token} onUnauth={handleLogout} />} />
        <Route path="schools/:schoolCode" element={<SchoolDetail token={token} onUnauth={handleLogout} />} />
        <Route path="fuel-registry"  element={<FuelRegistry    token={token} />} />
        <Route path="dataset-ops"    element={<DatasetOperations token={token} />} />
        <Route path="dataset-health" element={<DatasetHealth   token={token} onUnauth={handleLogout} />} />
        <Route path="svg-cache"      element={<SvgCacheManager token={token} />} />
        <Route path="pool-readiness" element={<PoolReadiness token={token} />} />
        <Route path="fln" element={<FLNHealth token={token} />} />
        <Route path="mitraa-responses" element={<MitraaResponses token={token} />} />
        <Route path="question-flags" element={<QuestionFlags token={token} />} />
      </Routes>
    </AdminLayout>
  );
}
